<template>
    <AppModal @close="onClose()" v-bind="$attrs" v-if="visible">
        <template v-slot:header>Add Organization Staff Role</template>
        <form @submit.prevent="onSubmit()">
            <transition name="fade">
                <AppNotification :type="alertMessage.type" v-if="alertMessage.message">
                    {{alertMessage.message}}
                </AppNotification>
            </transition>
            <div class="form-group">
                <label for="organizationRoleId">Role</label>
                <select :class="{'is-invalid': $v.organizationRoleId.$invalid}" class="form-control"
                        v-model="organizationRoleId">
                    <option :value="null" disabled>--Select Role--</option>
                    <option :key="role.id" :value="role.id" v-for="role in roles">{{role.name}}</option>
                </select>
                <span class="invalid-feedback" v-if="!$v.organizationRoleId.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="personId">Person</label>
                <select :class="{'is-invalid': $v.personId.$invalid}" class="form-control" v-model="personId">
                    <option :value="null" disabled>--Select Person--</option>
                    <option :key="person.id" :value="person.id" v-for="person in people">{{person.name}}</option>
                </select>
                <span class="invalid-feedback" v-if="!$v.personId.required">Field is required</span>
            </div>
            <div class="form-group">
                <AppCheckBox v-model="isPrimaryContact" :disabled="isPrimaryContactDisabled">Is Primary Contact
                </AppCheckBox>
            </div>
        </form>
        <template v-slot:footer>
            <button :disabled="isSubmitting" @click.prevent="onSubmit()" class="btn btn-primary" type="submit">Save
            </button>
            <button :disabled="isSubmitting" @click="onClose()" class="btn btn-danger" data-dismiss="modal"
                    type="button">
                Close
            </button>
        </template>
    </AppModal>
</template>

<script>
    import AppModal from "../shared/AppModal";
    import AppCheckBox from "../shared/AppCheckBox";
    import PersonService from "@/services/PersonService";
    import OrganizationService from "@/services/OrganizationService";
    import AppNotification from "@/components/shared/AppNotification";
    import {required} from "vuelidate/lib/validators";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppModal,
            AppCheckBox,
            AppNotification
        },
        data() {
            return {
                organizationRoleId: null,
                personId: null,
                isPrimaryContact: false,
                isSubmitting: false,
                people: [],
                roles: [{
                    id: 'DE7CF3BB-D0DC-4105-8DD9-3DC6D127C0FE',
                    name: 'Payroll Administrator'
                },
                    {
                        id: 'B3FB1535-4E38-44CD-A035-ACD5B11483EF',
                        name: 'Report Receiver-HUB'
                    },
                    {
                        id: 'C9F26065-C319-4A93-A058-BF24194F2E17',
                        name: 'Support Staff'
                    },
                    {
                        id: '95A28EB2-60BA-4F64-9F0C-88DE8F3BAA08',
                        name: 'Website Contact'
                    }],
                alertMessage: {
                    type: null,
                    message: null
                },
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true,
            },
            personOrganizationRoles: {
                type: Array
            },
            visible: {
                required: false,
                default: false
            }
        },
        watch: {
            visible() {
                this.personId = null;
                this.organizationRoleId = null;
                this.isPrimaryContact = false;
            },
            /**
             * @description Watches the organization role id. When it changes, auto disable the is primary contact if one
             * is already set in the org list
             */
            organizationRoleId(newVal) {
                if(!newVal)
                    return;

                const shouldBeDisabled = this.personOrganizationRoles.find(p => p.organizationRoleId.toUpperCase() === newVal.toUpperCase() && p.isPrimaryContact === true) !== undefined;

                if (shouldBeDisabled)
                    this.isPrimaryContact = false;
            },
        },
        computed: {
            /**
             * @description Indicates if the IsPrimaryContact checkbox should be disabled
             */
            isPrimaryContactDisabled() {
                if (!this.organizationRoleId)
                    return false;

                return this.personOrganizationRoles.find(p => p.organizationRoleId.toUpperCase() === this.organizationRoleId.toUpperCase() && p.isPrimaryContact === true) !== undefined;
            },
        },
        methods: {
            /**
             * @description Emits the close event to the parent
             */
            onClose() {
                this.$emit('close')
            },

            /**
             * @description Creates a new organization role and emits the event to the parent
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                OrganizationService.addOrganizationRole({
                    personId: vm.personId,
                    organizationId: vm.organizationId,
                    isPrimaryContact: vm.isPrimaryContact,
                    organizationRoleId: vm.organizationRoleId
                }).then(() => {
                    vm.alert(ToastType.Success, "The role was successfully created.");

                    vm.$emit('create');
                    vm.onClose();
                }).catch(function (error) {
                    vm.alertMessage.type = "danger";
                    vm.alertMessage.message = error.response.statusText;
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            const vm = this;

            PersonService.getAllPeople(false)
                .then(response => {
                    vm.people = response
                }).catch((error) => {
                vm.alert(ToastType.Danger, error.response.statusText);

                vm.onClose();
            })
        },
        validations: {
            organizationRoleId: {
                required
            },
            personId: {
                required
            }
        }
    }
</script>
